const TabContent = ({
  children,
  activeTab,
  tabKey,
  forceReturnValue,
  forceReturnContent,
}) => {
  if (activeTab === tabKey) {
    return children;
  }

  if (forceReturnValue) {
    if (forceReturnValue === activeTab) {
      if (forceReturnContent) {
        return forceReturnContent;
      }
      return children;
    }
  }

  return null;
};

export default TabContent;
